import { createContext, useContext, type PropsWithChildren } from "react";
import { type IUseActivityReturn, useActivityData } from "@hooks/game/activity/use-activity";

const ActivityContext = createContext<IUseActivityReturn | null>(null);

export const ActivityProvider = ({ children }: PropsWithChildren) => {
  const activityData = useActivityData();

  return <ActivityContext.Provider value={activityData}>{children}</ActivityContext.Provider>;
};

export const useActivityContext = () => {
  const context = useContext(ActivityContext);

  if (!context) {
    throw new Error("useActivityContext must be used within an ActivityProvider");
  }

  return context;
};
